import type { BaseKeyFunction } from "../../../../lib/types/baseKeyFunction";

export type KeyCommunitiesAdminCampaignDonorsProps = {
  communityId: number;
  campaignId: number;
};

export const keyCommunitiesAdminCampaignDonors: BaseKeyFunction<
  KeyCommunitiesAdminCampaignDonorsProps
> = ({ communityId, campaignId }) => [
  "communities-admin-campaign-donors",
  communityId.toString(),
  campaignId.toString(),
];
